import { render, staticRenderFns } from "./RbInputDate.vue?vue&type=template&id=35c1de37&"
import script from "./RbInputDate.vue?vue&type=script&lang=js&"
export * from "./RbInputDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports